import axios from '@/plugins/axios';

const baseQuery =
  'with[0]=customer_status&select=id,status,channel,custumer_code,company_name,rfc,a_estate,person_type,created_at,live_uuid,envelope_id';

export default {
  namespaced: true,
  state: {
    list: [],
    pagination: {
      page: 1,
      to: 1,
      per_page: 15,
      total: 0,
    },
  },

  getters: {
    jobs(state) {
      return state.list;
    },
    pagination(state) {
      return state.pagination;
    },
  },

  mutations: {
    SET_LIST(state, payload) {
      state.list = payload;
    },
    SET_PAGINATION(state, payload) {
      state.pagination.page = payload.current_page;
      state.pagination.to = payload.last_page ?? 1;
      state.pagination.per_page = payload.per_page ?? 15;
      state.pagination.total = payload.total ?? 0;
    },
  },

  actions: {
    async requestExport(_, { status, search }) {
      let querySearch = '';
      if (search && search !== '') {
        querySearch += '&search=%25' + search + '%25';
      }
      if (status) {
        querySearch += `&filter[status]=${status}`;
      }
      const response = await axios.get(
        `/customers/export?${baseQuery}${querySearch}`
      );
      return response.data;
    },

    async fetchDownloadJobs({ commit }, { per_page = 15, page = 1 } = {}) {
      const params = new URLSearchParams({ per_page, page });
      const response = await axios.get(`/download-jobs?${params.toString()}`);
      const {
        data: list = [],
        current_page = 1,
        last_page = 1,
        per_page: perPageResp = per_page,
        total = 0,
      } = response.data || {};
      commit('SET_LIST', Array.isArray(list) ? list : []);
      commit('SET_PAGINATION', {
        current_page,
        last_page,
        per_page: perPageResp,
        total: total || (Array.isArray(list) ? list.length : 0),
      });
      return response.data;
    },

    async fetchDownloadJob(_, id) {
      const response = await axios.get(`/download-jobs/${id}`);
      return response.data;
    },

    async downloadFile(_, id) {
      const response = await axios.get(`/download-jobs/${id}/download`, {
        responseType: 'blob',
      });
      const contentDisposition = response.headers['content-disposition'];
      let filename = 'solicitudes_clientes.xlsx';
      if (contentDisposition) {
        // Extraer el nombre del archivo del header Content-Disposition (ej. attachment; filename="archivo.xlsx")
        const match = contentDisposition.match(/filename="?(.+?)"?$/);
        if (match && match[1]) {
          filename = match[1].trim();
        }
      }
      return { blob: response.data, filename };
    },
  },
};
